import { render, staticRenderFns } from "./CommissionRules.html?vue&type=template&id=31add132&scoped=true&external"
import script from "./CommissionRules.js?vue&type=script&lang=js&external"
export * from "./CommissionRules.js?vue&type=script&lang=js&external"
import style0 from "./CommissionRules.vue?vue&type=style&index=0&id=31add132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31add132",
  null
  
)

export default component.exports